import { PAIRED_ACH_FIELD_ROWS } from 'components/Payments/payroc/lib/achFieldRows';
import NewACH from 'components/Payments/NewPayment/PaymentContent/components/PaymentMethods/Payroc/PayWithAchModal/components/NewACH';

import { useReportFormLoadError } from '../lib/formLoadErrorContext';

const PairedNewAch = (props) => {
  const reportLoadError = useReportFormLoadError();

  return <NewACH {...props} fieldRows={PAIRED_ACH_FIELD_ROWS} onLoadError={reportLoadError} />;
};

export default PairedNewAch;
